export const flowOptions = [
  { label: 'All', value: 'All' },
  { label: 'Credit', value: 'Credit' },
  { label: 'Debit', value: 'Debit' },
];

export const initialFilterState = {
  flow: flowOptions[0],
  dateRange: null,
  processMethod: { label: 'All', value: 'All' },
  amount: ['', ''],
  category: { label: 'All', value: 'All' },
  productName: { label: 'All', value: 'All' },
  interactionPoint: { label: 'All', value: 'All' },
};
